export const ROUTES = {
  home: "/",
  shop: "/shop",
  product: (slug: string) => `/p/${slug}`,
  cart: "/cart",
  checkout: "/checkout",
  order: (id: string) => `/order/${id}`,
  orderReturn: "/order/return",
  sale: "/sale",
  enrichmentClasses: "/enrichment-classes",
  about: "/about",
  contact: "/contact",
  faqs: "/faqs",
  track: "/track",
  account: "/account",
  accountOrders: "/account/orders",
  accountWishlist: "/account/wishlist",
  accountProfile: "/account/profile",
  accountAddresses: "/account/addresses",
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  verifyEmailChange: "/verify-email-change",
  bju: "/bju",
  lifepac: "/lifepac",
  livingBooks: "/living-books",
  tyndale: "/tyndale",
  privateProducts: "/private-products",
  returns: "/returns",
  shipping: "/shipping",
  intlShipping: "/intl-shipping",
  privacyPolicy: "/privacy-policy",
} as const;

export const COLLECTION_KINDS = [
  "bju",
  "lifepac",
  "living-books",
  "tyndale",
] as const;
export type CollectionKind = (typeof COLLECTION_KINDS)[number];
